import React from "react";

const Phone = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    fill="none"
    viewBox="0 0 12 2"
    {...props}
  >
    <path
      fill="currentColor"
      d="M11.25.25H.75a.75.75 0 0 0 0 1.5h10.5a.75.75 0 1 0 0-1.5"
    ></path>
  </svg>
);

export default Phone;
